import { Modal } from 'react-bootstrap';
import { setClassNames } from '@ddc/classnames-js';
import PropTypes from 'prop-types';

export const CustomModal = ({
	title,
	modalContent,
	isOpen,
	onClose,
	onOpen
}) => {
	const { isMobile } =
		(typeof window !== 'undefined' &&
			window &&
			window.DDC &&
			window.DDC.client) ||
		{};

	const dialogClassName = setClassNames([
		'my-0 mx-auto',
		!isMobile && 'center-block-vertical'
	]);

	const modalClassName = setClassNames([
		'responsive',
		isMobile && 'dock-right'
	]);

	return (
		<Modal
			show={isOpen}
			onHide={onClose}
			onShow={onOpen}
			className={modalClassName}
			dialogClassName={dialogClassName}
			backdropClassName="wsm-modal-backdrop"
		>
			<Modal.Header className="px-4 py-4 sticky-top">
				<Modal.Title className="text-sm-center font-weight-bold ddc-font-size-large">
					<button
						type="button"
						aria-label="Close"
						className="close mt-2"
						onClick={onClose}
					>
						<i
							className="ddc-icon ddc-icon-remove2 ddc-icon-size-large text-muted"
							aria-hidden="true"
						/>
					</button>
					<span>{title}</span>
				</Modal.Title>
			</Modal.Header>
			<Modal.Body className="overflow-auto pb-6 px-4 p-sm-6 mx-sm-6 mb-sm-6">
				{modalContent}
			</Modal.Body>
		</Modal>
	);
};
CustomModal.propTypes = {
	title: PropTypes.oneOfType([PropTypes.string, PropTypes.element])
		.isRequired,
	modalContent: PropTypes.oneOfType([PropTypes.string, PropTypes.element])
		.isRequired,
	isOpen: PropTypes.bool.isRequired,
	onClose: PropTypes.func.isRequired,
	onOpen: PropTypes.func
};
